module.exports = __webpack_public_path__ + "img/valueTrackingNo2.01a2fe22.png";